import type { PermissionSelector } from "@/hooks/usePermission";

export const canListPlatformGroups: PermissionSelector = (p) => p.isSuperAdmin;

export const canManagePlatformGroups: PermissionSelector = (p) => p.isSuperAdmin;
